import Vue from 'vue'
import Router from 'vue-router'
/** 首页 */
import HomePage from './views/home/HomePage'
/** 党组织申请 */
import ApplyFor from './views/home/ApplyFor'
/** 新闻详情 */
import NewsDetails from './views/home/NewsDetails'
/** 新闻列表 */
import NewsList from './views/home/NewsList'
/** 登录 */
import Login from './views/Login'
/** 注册 */
import Registered from './views/Registered'
/** 项目管理 */
import Project from './views/project/Project'
/** 项目管理 */
import Project_solicitation from './views/project/Project_solicitation'
/** 项目进度 */
import Schedule from './views/project/Schedule'
//非征集类型项目进度
import Schedule_solicitation from './views/project/Schedule_solicitation'
/** 项目创建 */
import Application from './views/project/Application'
/** 非征集类型项目申报页面 */
import Solicitation_entrance from './views/project/Solicitation_entrance'
/** 项目材料详情 */
import Excute from './views/excutes/Excute'
/** 非申报类型项目材料详情 */
import Excute_solicitation from './views/excutes/Excute_solicitation'
/** 结项材料详情 */
import Over from './views/excutes/Over'
/** 非申报类型结项材料详情 */
import Over_solicitation from './views/excutes/Over_solicitation'
/*中期评审材料提交*/
import Submit_mid from './views/excutes/Submit_mid'
/*非征集类型项目中期评审材料提交*/
import Submit_mid_solicitation from './views/excutes/Submit_mid_solicitation'
/*结项评审材料提交*/
import Post_pro from './views/excutes/Post_pro'
/*非征集类项目结项评审材料提交*/
import Post_pro_solicitation from './views/excutes/Post_pro_solicitation'
/** 个人中心 */
import PersonalZte from './views/personal/PersonalZte'
/** 党组织申请 */
import Apply from './views/personal/Apply'
/** 我的收藏 */
import Collection from './views/personal/Collection'
/** 项目申报 */
import Declare from './views/personal/Declare'
/** 非征集类型项目申报 */
import Solicitation from './views/personal/Solicitation'
/** 修改密码 */
import Modify from './views/personal/Modify'
/** 信息查询 */
import InformationQuery from './views/InformationQuery'
import Appcationnew from './views/project/Appcationnew'
// 党组织详情
import dangzuzhixq from './views/dangzuzhixq'
//社会信用
import socialcredit from './views/socialcredit'
// 活动详情监测
import activedetail from './views/activedetail'
// 中期详情
import middetail from './views/middetail'
// 项目类型过渡页
import TransitionPage from './views/TransitionPage'
Vue.use(Router)
// 获取原型对象上的push函数
const originalPush = Router.prototype.push
// 修改原型对象中的push方法
Router.prototype.push = function push(location) {
  return originalPush.call(this,location).catch(err => err)
}
export default new Router({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes: [
    {
      path:'/transitionPage',
      name:"transitionPage",
      meta:{
        requireAuth: true
      },
      component:TransitionPage
    },
    {
      path: '/informationQuery',
      name: 'informationQuery',
      component: InformationQuery
    },
    {
      path: '/modify',
      name: 'modify',
      meta: {
        requireAuth: true
      },
      component: Modify
    },
    {
      path: '/declare',
      name: 'declare',
      meta: {
        requireAuth: true
      },
      component: Declare
    },
    {
      path: '/solicitation',
      name: 'solicitation',
      meta: {
        requireAuth: true
      },
      component: Solicitation
    },
    {
      path: '/collection',
      name: 'collection',
      meta: {
        requireAuth: true
      },
      component: Collection
    },
    {
      path: '/apply',
      name: 'apply',
      meta: {
        requireAuth: true
      },
      component: Apply
    },
    {
      path: '/submit_mid',
      name: 'submit_mid',
      meta: {
        requireAuth: true
      },
      component: Submit_mid
    },
    {
      path: '/submit_mid_solicitation',
      name: 'submit_mid_solicitation',
      meta: {
        requireAuth: true
      },
      component: Submit_mid_solicitation
    },
    {
      path: '/post_pro',
      name: 'post_pro',
      meta: {
        requireAuth: true
      },
      component: Post_pro
    },
    {
      path: '/post_pro_solicitation',
      name: 'post_pro_solicitation',
      meta: {
        requireAuth: true
      },
      component: Post_pro_solicitation
    },
    {
      path: '/excute',
      name: 'excute',
      meta: {
        requireAuth: true
      },
      component: Excute
    },
    {
      path: '/excute_solicitation',
      name: 'excute_solicitation',
      meta: {
        requireAuth: true
      },
      component: Excute_solicitation
    },
    {
      path: '/over',
      name: 'over',
      meta: {
        requireAuth: true
      },
      component: Over
    },
    {
      path: '/over_solicitation',
      name: 'over_solicitation',
      meta: {
        requireAuth: true
      },
      component: Over_solicitation
    },
    {
      path: '/personalZte',
      name: 'personalZte',
      meta: {
        requireAuth: true
      },
      component: PersonalZte
    },
    {
      path: '/application',
      name: 'application',
      meta: {
        requireAuth: true
      },
      component: Application
    },
    {
      path: '/solicitation_entrance',
      name: 'solicitation_entrance',
      meta: {
        requireAuth: true
      },
      component: Solicitation_entrance
    },
    {
      path: '/appcationnew',
      name: 'appcationnew',
      meta: {
        requireAuth: true
      },
      component: Appcationnew
    },
    {
      path: '/schedule/:id',
      name: 'schedule',
      meta: {
        requireAuth: true
      },
      component: Schedule
    },
    {
      path: '/schedule_solicitation/:id',
      name: 'schedule_solicitation',
      meta: {
        requireAuth: true
      },
      component: Schedule_solicitation
    },
    {
      path: '/project',
      name: 'project',
      meta: {
        requireAuth: true
      },
      component: Project
    },
     {
      path: '/Project_solicitation',
      name: 'project_solicitation',
      meta: {
        requireAuth: true
      },
      component: Project_solicitation
    },
    {
      path: '/registered',
      name: 'registered',
      component: Registered
    },
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/dangzuzhixq',
      name: 'dangzuzhixq',
      component: dangzuzhixq
    },
    {
      path: '/middetail',
      name: 'middetail',
      component: middetail
    },
    {
      path: '/activedetail',
      name: 'activedetail',
      component: activedetail
    },
    {
      path: '/socialcredit',
      name: 'socialcredit',
      meta: {
        requireAuth: true
      },
      component: socialcredit
    },
    {
      path: '/newsList',
      name: 'newsList',
      component: NewsList
    },
    {
      path: '/newsDetails',
      name: 'newsDetails',
      component: NewsDetails
    },
    {
      path: '/applyFor',
      name: 'applyFor',
      meta: {
        requireAuth: true
      },
      component: ApplyFor
    },
    {
      path: '/',
      name: 'homePage',
      component: HomePage
    },
  ]
})
